var React = require('react');

function Arrowwithtail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6806 8.46159 14.0474 8.07107 13.6569L3.41421 9.00001L22 9.00001C22.5523 9.00001 23 8.55229 23 8.00001C23 7.44772 22.5523 7.00001 22 7.00001L3.41421 7.00001L8.07107 2.34315C8.46159 1.95263 8.46159 1.31947 8.07107 0.928941C7.68054 0.538416 7.04738 0.538416 6.65686 0.928941L0.292893 7.2929C-0.0976309 7.68342 -0.097631 8.31659 0.292893 8.70711Z","fill":"#BA0707"}));
}

Arrowwithtail.defaultProps = {"width":"23","height":"16","viewBox":"0 0 23 16","fill":"none"};

module.exports = Arrowwithtail;

Arrowwithtail.default = Arrowwithtail;
